import * as React from 'react';
import Box from '@mui/material/Box';
import CommonButtonHeader from '../CommonButtonHeader';
import ViewClientAccount from './ViewClientAccount';

const ClientAccountHome = () => {

    return (
        <Box sx={{ width: '100%' }}>
            {/* <CommonButtonHeader /> */}

            <ViewClientAccount />
        </Box>
    );
}

export default ClientAccountHome